import { render, staticRenderFns } from "./MobFullIndex.vue?vue&type=template&id=53fe216f&scoped=true"
import script from "./MobFullIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./MobFullIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobFullIndex.vue?vue&type=style&index=0&id=53fe216f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe216f",
  null
  
)

export default component.exports